/* eslint-disable @typescript-eslint/naming-convention */
import clsx from "clsx";

import {
  INDEX_NOT_FOUND,
  IProductionPollState,
  isProductionPollStateFinished,
  isProductionPollStateNotStarted,
  isProductionPollStateTerminal,
  isProductionStatusActive,
  isProductionStatusFailed,
  isProductionStatusFinished,
  isProductionStatusNotStarted,
  ProductionStatusEnum,
} from "@ryde/shared";

export const isProductionChainEmptyFinished = (
  state: IProductionPollState,
): boolean => {
  return (
    isProductionPollStateFinished(state) &&
    !state.data.allInputBookingIds?.length
  );
};

const resolveChainStepStatusClass = (status: ProductionStatusEnum): string => {
  switch (true) {
    case isProductionStatusNotStarted(status):
      return "chain-step--created";
    case isProductionStatusActive(status):
      return "chain-step--in-progress";
    case isProductionStatusFailed(status):
      return "chain-step--failed";
    case isProductionStatusFinished(status):
      return "chain-step--finished";
    default:
      return "";
  }
};

export const resolveStepClassName = ({
  state,
  productionUiId,
  index,
  nextIndexToStart,
}: {
  state: IProductionPollState;
  productionUiId: number | undefined;
  index: number;
  nextIndexToStart: number;
}): string => {
  return clsx("chain-step", resolveChainStepStatusClass(state.status), {
    "chain-step--active": state.productionId === productionUiId,
    "chain-step--next": index === nextIndexToStart,
    "chain-step--empty-finished": isProductionChainEmptyFinished(state),
  });
};

export const resolveNextChainIndex = (
  states: IProductionPollState[],
): number => {
  for (let i = 0; i < states.length; i++) {
    const isTerminal = isProductionPollStateTerminal(states[i]);

    if (!isTerminal) {
      continue;
    }

    const nextState = states[i + 1];

    if (isProductionPollStateNotStarted(nextState)) {
      return i + 1;
    }
  }

  return INDEX_NOT_FOUND;
};
